import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';

export interface IResponse {
    isValid: boolean;
}

const signUpOrgNameValidate = async (orgName: string): Promise<IResponse> => {
    const response = await axiosInstance.get(`${API_ENDPOINTS.SIGNUP.ORG_NAME_VALIDATE(orgName)}`);
    return response.data;
};

export const useSignUpUserAndOrgValidate = (orgName: string, options?: any) => useQuery<IResponse, Error>({
    queryKey: [QUERY_KEYS.SIGNUP.ORG_NAME_VALIDATE, orgName],
    queryFn: () => signUpOrgNameValidate(orgName),
    ...options,
});

export default useSignUpUserAndOrgValidate;
